import {z} from 'zod';

export const featuresSchema = z.object({
  disableMerchantInviteInAdmin: z.boolean().optional(),
  disablePortalPayments: z.boolean().optional(),
  disablePortalRefund: z.boolean().optional(),
  askForDocumentsInMerchantApplication: z
    .object({
      // file upload description texts on the merchant application page
      title: z.string().optional(),
      description: z.string().optional(),
    })
    .optional(),
  requireL2DataInPortalPayment: z.boolean().optional(),
  enableTerminals: z.boolean().optional(),
  // increases payment amount with an additional value.
  enableSurcharges: z.boolean().optional(),
  // payment amount stays the same. Additional commission is being taken on the split configuration level.
  // special feature for Blaze
  enableSurchargesViaAdditionalCommission: z.boolean().optional(),
  enableInterchangeReport: z
    .object({
      // icsf details should be enabled in tenant's payment accounting reports
      showInterchangeReportPage: z.boolean().optional(),
      // for dev purposes when icsf details not enabled
      mockCreditCardFeeDetails: z.boolean().optional(),
    })
    .optional(),
  merchantReferenceIdRequired: z.boolean().optional(),
  enableManagedRisk: z.boolean().optional(),
  enableMultiStore: z.boolean().optional(),
  enableCustomerSavedPaymentMethods: z.boolean().optional(),
  requestHopPCI: z.boolean().optional(),
  staticMerchantTimeZone: z.string().optional(),
  enableCapital: z.boolean().optional(),
  enableRefundsInAdmin: z.boolean().optional(),
  // When SSO is enabled in admin, we should disable all user management features and hide users page
  disableAdminUserManagement: z.boolean().optional(),
  showAuthorizationsInPortalVolume: z.boolean().optional(),
});
